export default __webpack_public_path__ + "22ba41b5674459d00a2a53a7d952d142.webp";